import { useMutation } from "@tanstack/react-query";
import { api } from "@contexts";
import { Doctor } from "@interfaces";

interface UpdateDoctorContactPayload {
  email: string;
  phone: string;
}

interface UseUpdateDoctorContactProps {
  rut: string;
}

export const useUpdateDoctorContact = ({
  rut,
}: UseUpdateDoctorContactProps) => {
  const updateContactFn = (payload: UpdateDoctorContactPayload) => {
    return api<Doctor>({
      url: `/doctors/contact/${rut}`,
      method: "PATCH",
      data: payload,
    });
  };

  return useMutation({
    mutationFn: updateContactFn,
  });
};
